/* This is the starting point of the code, everything gets kicked off here */

"use strict";

import jQuery from "../scripts/vendor/jquery";
(window as any).$ = (window as any).jQuery = jQuery;

import "regenerator-runtime/runtime.js";

// Polyfill for the https://developer.mozilla.org/en-US/docs/Web/API/CookieStore API
import "cookie-store";
import "throttle-debounce";

//vendor and realise utility stuff - could be a bundle
import "./utility/bootstrap-env-check";
import "./utility/event-dispatcher";
import "./utility/jquery-picture.modified";
import "./utility/throttled-resize";
import "./vendor/bootstrap-collapse";
import "./vendor/bootstrap-modal";
import "./vendor/bootstrap-tab";
import "./vendor/bootstrap-transition";

//analytics
import "./utility/analytics-controller";
import "./utility/analytics-reference";
import "./utility/analytics-sitewide";

import "../components/cookies-bar/cookies-bar";
import "./utility/toggle-class";

import "../components/accordion/accordions";
import "../components/cta-slider-block/cta-slider-block";
import "../components/hero-slider/hero-slider";
import "../components/hero-video/hero-video";
import "../components/media-gallery/media-gallery";
import "../components/product-breadcrumbs/product-breadcrumbs";
import "../components/product-sidebar/fixture-selector";
import "../components/product-sidebar/upcoming-fixtures/upcoming-fixtures";
import "../components/promo-block/promo-block";
import "../components/site-banner/site-banner";
import "../components/table-block/table-scrollable";
import "../components/tabs/tabs";
import "../components/testimonial-list/testimonial-list";
import "../components/video-archive/video-archive";
import "../components/video/video-native";
import "../components/video/video-vimeo";
import "../components/video/video-youtube";
import "./utility/disable-hover";
import "./utility/list-to-accordion";
import "./utility/modal";
import "./utility/order-history-filter";

//jstorage - for working with local storage and cookies
//TODO: Look at replacing this with pure access to local storage as we don't use the TTL features.
// import "./local-storage";
import "./vendor/jstorage";

//search
import "../components/search/search-form";

import { initAsyncForms } from "../components/async-form/";
import { initCtaGridTracking } from "../components/cta-grid-tracking/cta-grid-tracking";
import { initFestivalHubNavigation } from "../components/festival-hub-navigation-block/festival-hub-navigation-block";
import { togglePasswordVisibility } from "../components/form-components/inputPassword/inputPassword";
import { initScrollObserver } from "../components/scroll-observer/_scroll-observer";
import { initNavigation } from "../components/site-header/";
import { initTicketing } from "../components/ticketing";
import { initDayJs } from "./utility/dayjs";
import { linkToggler } from "./utility/linkToggler";

import initCarousels from "../components/carousel/carousel";
import initBookNowDrawer from "../components/book-now-drawer/initBookNowDrawer";
import "./autoCompleteAddress.js";
import { toggleState } from "./utility/toggleState";

function eagerInit() {
  initDayJs();
  initNavigation();
  initFestivalHubNavigation();
  initScrollObserver();
  initBookNowDrawer();
  initCtaGridTracking();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    eagerInit();
  });
} else {
  eagerInit();
}

window.addEventListener("load", async () => {
  initTicketing();
  togglePasswordVisibility();
  initAsyncForms();
  // Toggler for user account navigation on mobile
  linkToggler("[data-toggler]", "active");
  toggleState("[data-friends-list]", "friendsList", "active"); // Toggle for adding a new contact on friends list
  toggleState("[data-friend]", "friend", "active"); // Toggle for confirmation for removing a contact on friends list
  initCarousels();
  // Lazy load components
  if (document.querySelector("[data-qr-code]")) {
    const { generateQrCode } = await import("../utils/qrCodeGenerator");
    generateQrCode("[data-qr-code]");
  }

  if (document.querySelector(".map-block .map")) {
    await import("../components/map/map");
  }

  if (document.querySelector(".google-recaptcha-token")) {
    const { initRecaptcha } = await import("../components/recaptcha/");
    initRecaptcha();
  }

  if (document.querySelector("[data-ticketing-tab]")) {
    const { initTicketingTabs } = await import("../components/ticketing/tabs/ticketing-tabs");
    initTicketingTabs();
  }

  if (document.querySelector("[data-ticketing-static-trigger]")) {
    import("../components/ticketing/tabs/ticketing-tabs-static");
  }

  if (document.querySelector(".additional-information .trigger") || document.querySelector("[data-toggle-tickets]")) {
    import("../components/ticketing/tabs/toggle-tickets");
  }

  if (document.querySelector(".announcement-popup")) {
    const { initializeModal } = await import("../components/popup-extension/popup-extension");
    initializeModal();
  }

  if (document.querySelector("[data-filter-url]")) {
    import("../components/cta-listing-filter/filter");
  }

  if (document.querySelector(".product-carousel")) {
    import("../components/product-carousel/product-carousel");
  }

  if (document.querySelector(".product-detail-view")) {
    import("../components/product-sidebar/product-detail-view/product-detail-view");
  }
});
